import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { AuthguardGuard } from "./authguard.guard";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";

const appRoutes: Routes = [
  {path: "auth",  loadChildren: () => import('./components/Authorization/authorization.module').then(m => m.AuthorizationModule) },
  { path: "patient", canActivate: [AuthguardGuard], canActivateChild: [AuthguardGuard], loadChildren: () => import('./components/patient/patient.module').then(m => m.PatientModule) },
  { path: "admin", loadChildren: () => import('./components/admin/admin/admin.module').then(m => m.AdminModule) },
  { path: 'notfound', component: PageNotFoundComponent },
  { path: '', redirectTo: 'auth', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true, relativeLinkResolution: 'legacy'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
